export default __webpack_public_path__ + "static/media/blank.abe9a8e7.jpg";